import { ErrorResponseCode } from '@/coreInfrastructureModule/axios/generated/orderManage';
import type { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { i18n } from '@/i18n';

const t = i18n.t;

/**
 * 発注テンプレート機能のエラーコードをユーザーに伝える文言へ変換する
 * @param error - APIから受け取ったエラー情報
 * @param fallbackMessage - マッピングできなかった場合に表示する文言
 */
export const resolveOrderTemplateErrorMessage = (error: IError | null | undefined, fallbackMessage: string): string => {
  if (!error) {
    return fallbackMessage;
  }

  switch (error.code) {
    case ErrorResponseCode.BadRequest:
      return t('送信内容に誤りがあります。入力内容を確認してください。') as string;
    case ErrorResponseCode.NotRegisteredBusiness:
      return t('必要な登録情報が不足しています。システム管理者に連絡してください。') as string;
    case ErrorResponseCode.FkConstraintFailed:
      return t('関連情報との整合が取れず処理できませんでした。画面を再読み込みしてください。') as string;
    case ErrorResponseCode.Unauthorized:
    case ErrorResponseCode.Forbidden:
      return t('操作権限がありません。システム管理者にお問い合わせください。') as string;
    case ErrorResponseCode.NotFound:
    case 'notExist':
      return t('対象データが見つかりませんでした。画面を更新して再度お試しください。') as string;
    case ErrorResponseCode.ResourceConflict:
    case ErrorResponseCode.UpdateTimingConflict:
    case 'alreadyExist':
      return t('他のユーザーの操作と競合したため処理できませんでした。画面を更新してやり直してください。') as string;
    case ErrorResponseCode.InternalServerError:
      return t('サーバーでエラーが発生しました。しばらくしてから再試行してください。') as string;
    default:
      return fallbackMessage;
  }
};
